/* 구글 태그(gtag.js) 얇은 래퍼 — 2026-09-21 김현비
 *
 * 태그 자체는 public/index.html 에서 불러온다. 여기는 "언제 무엇을 보낼지"만 담는다.
 *
 * 구글애즈 전환 아이디(AW-…/라벨)는 아직 안 받았다.
 * .env 에 값이 들어오는 순간부터 전환이 나가고, 값이 없으면 조용히 아무것도 안 한다(에러 X).
 *   REACT_APP_GADS_ID          = AW-0000000000
 *   REACT_APP_GADS_CONV_QUOTE  = AW-0000000000/xxxxxxxx   (견적서 발급 완료)
 *   REACT_APP_GADS_CONV_STORE  = AW-0000000000/yyyyyyyy   (네이버 스토어로 이동 = 구매 직전)
 */

import { trackAdActivity } from "./adAnalytics";

const GADS_ID = process.env.REACT_APP_GADS_ID || "";
let adsConfigured = false;

function push(...args) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag(...args);
  } catch (e) {
    /* 광고 차단기 등으로 태그가 안 뜬 경우 — 화면을 멈추게 하지 않는다 */
  }
}

/* 애즈 계정은 전환을 처음 보낼 때 한 번만 붙인다 */
function ensureAdsConfig() {
  if (adsConfigured || !GADS_ID) return;
  push("config", GADS_ID);
  adsConfigured = true;
}

/** 화면 이동마다 1회. SPA 라 index.html 의 자동 page_view 는 꺼 뒀다. */
export function trackPageView(path) {
  push("event", "page_view", {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : undefined,
    page_title: typeof document !== "undefined" ? document.title : undefined,
  });
}

/** GA4 일반 이벤트 */
export function trackEvent(name, params = {}) {
  if (name === "generate_lead") trackAdActivity("quote_issued");
  if (name === "begin_checkout") trackAdActivity("store_open");
  push("event", name, params);
}

/** 구글애즈 전환. sendTo 가 비어 있으면(아이디 미수령) 아무것도 안 한다. */
export function trackAdsConversion(sendTo, params = {}) {
  if (!sendTo) return;
  ensureAdsConfig();
  push("event", "conversion", { send_to: sendTo, ...params });
}

/** 전환 지점별 send_to 값 모음 */
export const ADS_CONV = {
  quote: process.env.REACT_APP_GADS_CONV_QUOTE || "",
  store: process.env.REACT_APP_GADS_CONV_STORE || "",
};
